import { render, staticRenderFns } from "./papers.vue?vue&type=template&id=0edee0b0&"
import script from "./papers.vue?vue&type=script&lang=js&"
export * from "./papers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports